import React, { Component } from 'react';

class Header extends Component {
   render() {

      if (this.props.data) {
         var networks = this.props.data.social.map(function (network) {
            return <li key={network.name}><a href={network.url} target="_blank"><i className={network.className}></i></a></li>
         })
      }

      return (
         <header id="home">
            <nav id="nav-wrap">
               <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Mostrar navegação</a>
               <a className="mobile-btn" href="#home" title="Hide navigation">Ocultar navegação</a>

               <ul id="nav" className="nav">
                  <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
                  <li><a className="smoothscroll" href="#about">About me</a></li>
                  <li><a className="smoothscroll" href="#testimonials">Testimonial</a></li>
                  <li><a className="smoothscroll" href="#contact">Contact</a></li>
               </ul>
            </nav>

            <div className="row banner">
               <div className="banner-text">
                  <h1>
                     Elisabete Monteiro</h1>
                  <h3 className="responsive-headline">Individual and personalized online private lessons of BRAZILIAN PORTUGUESE to FOREIGNERS. Lessons via Skype with support by whatsapp.
<br />For more information, visit the links below or click <a href="#contact">here</a> to contact me.</h3>
                  <hr />
                  <ul className="social">
                     {networks}
                  </ul>
               </div>
            </div>

            <p className="scrolldown">
               <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
            </p>
         </header>
      );
   }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js